export const DOCUMENT_SIGN_REQUEST = 'DOCUMENT_SIGN_REQUEST'
export const DOCUMENT_SIGN_SUCCESS = 'DOCUMENT_SIGN_SUCCESS'
export const DOCUMENT_SIGN_FAIL = 'DOCUMENT_SIGN_FAIL'
